import { observer } from 'mobx-react-lite'
import { IconButton, Button, Typography, Divider } from 'shared/ui'
import { useBreakdownFilterContext } from 'pages/analytics/ui/BreakdownFilter/context/breakdownFilterContext'
import styles from './styles.module.scss'

export const BreakdownFilterTrigger = observer(({ active }: { active: boolean }) => {
  const { hasAppliedFilters, appliedFiltersCount } = useBreakdownFilterContext()

  if (!hasAppliedFilters) {
    return (
      <IconButton
        active={active}
        fontSize={16}
        icon='filter'
        variant='outlined'
        color='secondary'
        ariaLabel='BreakdownFilter_trigger'
      />
    )
  }

  const buttonContent = (
    <div className={styles.appliedFilterButton}>
      <Divider
        orientation='vertical'
        style={{ height: '16px', borderColor: 'var(--border-neutral-primary)' }}
      />
      <Typography
        variant={'body-xs-medium'}
        className={styles.count}
        ariaLabel={'BreakdownAppliedFiltersCount'}
      >
        {appliedFiltersCount}
      </Typography>
    </div>
  )

  return (
    <Button
      active={active || hasAppliedFilters}
      size='medium'
      contained='secondary'
      icon='filter'
      titleContent={buttonContent}
    />
  )
})
